import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row mb-3",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_2 = { style: {"flex":"0 0 66.66%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%","display":"flex","flex-direction":"column","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"4px","font-size":"0.8rem"} }, " Mẫu số 02-VT "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"4px","font-size":"0.8rem"} }, " (Ban hành theo QĐ số: 200/2014/TT-BTC "),
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap","margin-bottom":"0","font-size":"0.8rem"} }, " Ngày 22/12/2014 của Bộ trưởng BTC) ")
], -1)
const _hoisted_4 = { style: {"margin-bottom":"0.75rem"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"1.5rem"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%"} }, null, -1)
const _hoisted_7 = { style: {"flex":"0 0 33.33%","text-align":"center"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { style: {"font-weight":"bold","margin-bottom":"8px"} }, " PHIẾU XUẤT KHO ", -1)
const _hoisted_9 = { style: {"margin-bottom":"4px","font-style":"italic"} }
const _hoisted_10 = { style: {"margin-bottom":"0"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%"} }, null, -1)
const _hoisted_12 = { style: {"font-size":"0.85rem","margin-bottom":"1rem"} }
const _hoisted_13 = { style: {"margin-bottom":"8px","word-break":"break-word"} }
const _hoisted_14 = { style: {"margin-right":"2rem"} }
const _hoisted_15 = { style: {"margin-bottom":"8px","word-break":"break-word"} }
const _hoisted_16 = { style: {"margin-right":"8px"} }
const _hoisted_17 = { style: {"margin-right":"12px"} }
const _hoisted_18 = { style: {"margin-bottom":"8px","word-break":"break-word"} }
const _hoisted_19 = { style: {"margin-right":"2rem"} }
const _hoisted_20 = {
  key: 0,
  style: {"margin-bottom":"0","word-break":"break-word"}
}
const _hoisted_21 = { style: {"margin-right":"2rem"} }
const _hoisted_22 = {
  class: "pdf-print-table",
  style: {"font-size":"0.8rem","margin-bottom":"1rem"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"40px"} }, "TT", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, " Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"90px"} }, "Mã vật tư", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"70px"} }, "ĐVT", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"90px"} }, "Số lượng", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Đơn giá", -1)
const _hoisted_29 = {
  key: 0,
  style: {"width":"200px"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "Thành tiền", -1)
const _hoisted_31 = { style: {"text-align":"left"} }
const _hoisted_32 = { style: {"text-align":"left"} }
const _hoisted_33 = { style: {"text-align":"left"} }
const _hoisted_34 = { style: {"text-align":"left"} }
const _hoisted_35 = { style: {"text-align":"right"} }
const _hoisted_36 = { style: {"text-align":"right"} }
const _hoisted_37 = {
  key: 0,
  style: {"text-align":"left","word-break":"break-word"}
}
const _hoisted_38 = { style: {"text-align":"right"} }
const _hoisted_39 = { class: "pdf-print-table-total-row" }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("strong", null, "Tổng cộng", -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { style: {"text-align":"right"} }
const _hoisted_44 = { style: {"text-align":"right","margin-bottom":"1.5rem","word-break":"break-word"} }
const _hoisted_45 = { style: {"font-style":"italic"} }
const _hoisted_46 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_47 = { style: {"font-weight":"bold","margin":"0 0 4px","font-size":"0.85rem"} }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","font-size":"0.75rem"} }, "(Ký, họ tên)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_PdfAccountingHeader = _resolveComponent("PdfAccountingHeader")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Phiếu xuất kho",
    "title-suffix": _ctx.phieuXuatData?.so_phieu,
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "phieu-xuat-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.phieuXuatData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "printing-paper",
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_PdfDocumentHeader, {
                    "ten-don-vi": _ctx.tenDonVi,
                    "ten-don-vi-cha": _ctx.tenDonViCha
                  }, null, 8, ["ten-don-vi", "ten-don-vi-cha"])
                ]),
                _hoisted_3
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_PdfAccountingHeader, {
                  "tai-khoan-no": _ctx.taiKhoanNo,
                  "tai-khoan-co": _ctx.taiKhoanCo
                }, null, 8, ["tai-khoan-no", "tai-khoan-co"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.ngayXuatKhoDisplay), 1),
                  _createElementVNode("p", _hoisted_10, [
                    _createTextVNode(" Phiếu xuất kho số: "),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.phieuXuatData.so_phieu), 1)
                  ])
                ]),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, [
                  _createTextVNode(" Họ, tên người nhận hàng: "),
                  _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.phieuXuatData.ten_nguoi_nhan), 1),
                  _createTextVNode(" Địa chỉ (bộ phận): .................................................. ")
                ]),
                _createElementVNode("p", _hoisted_15, [
                  _createTextVNode(" Lý do xuất kho: "),
                  _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.phieuXuatData.ly_do ||
              "....................................................."), 1),
                  (_ctx.phieuXuatData.loai_phieu === 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Theo biên bản số: "),
                        _createElementVNode("strong", _hoisted_17, _toDisplayString(_ctx.phieuXuatData.bien_ban_giai_the?.so_bien_ban ||
                "...................."), 1),
                        _createTextVNode(" Ngày: "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.ngayVaoXuongDisplay), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_18, [
                  _createTextVNode(" Xuất tại kho: "),
                  _createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.phieuXuatData.kho?.ten_kho), 1)
                ]),
                (_ctx.phieuXuatData.ngay_hoan_thanh)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                      _createTextVNode(" - Ngày hoàn thành: "),
                      _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.formatDisplayingDate(_ctx.phieuXuatData.ngay_hoan_thanh)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28,
                    (_ctx.phieuXuatData.loai_phieu === 2)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_29, " Lý do "))
                      : _createCommentVNode("", true),
                    _hoisted_30
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phieuXuatData.vat_tu_xuat_kho, (vatTu, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: vatTu.id,
                      class: _normalizeClass({
                'pdf-print-table-data-row': true,
                'pdf-print-table-data-row--last':
                  index === _ctx.phieuXuatData.vat_tu_xuat_kho.length - 1,
              })
                    }, [
                      _createElementVNode("td", _hoisted_31, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(vatTu.ten_vat_tu), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(vatTu.ma_vat_tu), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(vatTu.don_vi_tinh), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.formatUnitPrice(+(vatTu.pivot?.don_gia ?? 0))), 1),
                      (_ctx.phieuXuatData.loai_phieu === 2)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(vatTu.pivot.ghi_chu ? vatTu.pivot.ghi_chu : ""), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_38, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
                    _ctx.calcLineAmount(
                      +(vatTu.pivot.don_gia ?? 0),
                      +vatTu.pivot.so_luong
                    )
                  )), 1)
                      ])
                    ], 2))
                  }), 128)),
                  _createElementVNode("tr", _hoisted_39, [
                    _createElementVNode("td", {
                      colspan: _ctx.phieuXuatData.loai_phieu === 2 ? 7 : 6,
                      style: {"text-align":"right"}
                    }, _hoisted_42, 8, _hoisted_40),
                    _createElementVNode("td", _hoisted_43, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(_ctx.totalPrice)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createTextVNode(" Tổng số tiền (viết bằng chữ): "),
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.tongTienInText), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatureLabels, (sig) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: sig,
                    style: {"text-align":"center"}
                  }, [
                    _createElementVNode("p", _hoisted_47, _toDisplayString(sig), 1),
                    _hoisted_48
                  ]))
                }), 128))
              ])
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title-suffix", "source", "file-name", "loading"]))
}